import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { isMacOs } from 'Helpers/OperatingSystem';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {},
  keyCombination: {
    paddingTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  plus: {
    padding: theme.spacing(0, 1),
  },
  keyboardKey: {
    padding: theme.spacing(0.25, 1),
    backgroundColor: theme.palette.common.black,
    borderRadius: theme.radius.xs,
  },
});

const TooltipTitle = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.title}
        color={'white'}
      >
        {'Search Facet'}
      </Typography>
      <div className={classes.keyCombination}>
        <Typography
          className={classes.keyboardKey}
          color={'white'}
          component={'span'}
        >
          {(isMacOs()) ? 'Option' : 'Alt'}
        </Typography>
        <Typography
          className={classes.plus}
          color={'white'}
        >
          {'+'}
        </Typography>
        <Typography
          className={classes.keyboardKey}
          color={'white'}
          component={'span'}
        >
          {'K'}
        </Typography>
      </div>
    </Box>
  );
};

TooltipTitle.defaultProps = {
  className: '',
};

TooltipTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TooltipTitle);
